import { Injectable } from '@angular/core';
import { DestroyableComponent } from '@models/destroyable.component';
import { Collection } from 'lingo2-models';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
@Injectable()
export class CollectionsSidebarService extends DestroyableComponent {
  private collection = this.register(new BehaviorSubject<Collection>(null));
  public collection$ = this.collection.asObservable();

  constructor() {
    super();
  }

  public setCollection(collection: Collection) {
    this.collection.next(collection);
  }
}
